module.exports = __webpack_public_path__ + "static/omnisend-8a052f9b97de62548ff545f9d650d7c0.png";